import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/oxanium/wght.css';
import App from './App';
import '../styles/globals.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
